import { videoPostedApi } from "@/apis/apis";
import { FILTER_TYPE } from "@/constant/constants";
import { booleanOptionFilters } from "@/constant/GeneralOptions/boolean";
import { columns } from "./Columns";
import BaseTable from "./BaseTable";
import Actions from "./BaseTable/Actions";
import React, {useCallback, useMemo} from "react";
import AdminAdjustmentActionModal from "@/Modals/AdminAdjustmentAction";

export default function VideoPostedPage() {
  // const booleanOptionFiltersMap = booleanOptionFilters();
  // const roleTypeFiltersMap = roleTypeFilters();
  // const additionalFilters = [
  //   {
  //     id: "filter[type]",
  //     label: "Type",
  //     type: FILTER_TYPE.SELECT,
  //     options: roleTypeFiltersMap,
  //   },
  //   {
  //     id: "filter[newsletter_subscription]",
  //     label: "Newsletter?",
  //     type: FILTER_TYPE.SELECT,
  //     options: booleanOptionFiltersMap,
  //   },
  //   {
  //     id: "filter[term_conditions_accepted_at]",
  //     label: "T&C?",
  //     type: FILTER_TYPE.SELECT,
  //     options: booleanOptionFiltersMap,
  //   },
  //   {
  //     id: "filter[privacy_policy_accepted_at]",
  //     label: "Privacy Policy?",
  //     type: FILTER_TYPE.SELECT,
  //     options: booleanOptionFiltersMap,
  //   },
  // ];

  return (
    <BaseTable
      label="Video Posted"
      apiURL={videoPostedApi}
      columns={columns()}
      enableAdd={false}
    />
  );
}
